import React from 'react';
import { RELATED_GUIDES } from '../seo/marketingSeo';

/**
 * Links from a marketing service page into the static guide library.
 *
 * These are plain anchors rather than router Links on purpose. The guides are
 * static HTML served outside the React bundle, so a client side route change
 * would land on the SPA fallback instead of the article.
 */
const RelatedGuides = ({ page, heading = 'Read Before You Decide', intro }) => {
  const items = RELATED_GUIDES[page] || [];
  if (!items.length) return null;

  return (
    <section className="section-alt">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">Guides</span>
          <h2>{heading}</h2>
          {intro ? <p>{intro}</p> : null}
        </div>
        <div className="guide-grid">
          {items.map((g) => (
            <a className="guide-card" key={g.href} href={g.href}>
              <span className="guide-card-title">{g.title}</span>
              <span className="guide-card-blurb">{g.blurb}</span>
            </a>
          ))}
        </div>
        <p className="guide-all">
          <a href="/guides/">Browse all guides on FBR and PRA digital invoicing</a>
        </p>
      </div>
    </section>
  );
};

export default RelatedGuides;
